import { useContext } from 'react';

import {
  ExposeTrackingContext,
  type ExposeTrackingContextType,
} from '@/components/property-expose/ExposeTrackingProvider/ExposeTrackingProvider';

export const useExposeTracking = (): ExposeTrackingContextType => {
  const ctx = useContext(ExposeTrackingContext);
  // oxlint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (ctx === undefined) {
    throw new Error('useExposeTracking used outside of ExposeTrackingProvider!');
  } else {
    return ctx;
  }
};
